export default "__VITE_ASSET__CJXiguyM__"